// 目录页
export const useGetCategoryFinalPriceAndCrossPrice = ({ product }) => {
  const { price_range } = product || {};

  const { maximum_price, minimum_price } = price_range || {};

  const { final_price: maximum_price_final_price } = maximum_price || {};
  const maximum_price_regular_price_value = maximum_price?.regular_price?.value;

  const { final_price: minimum_price_final_price } = minimum_price || {};

  const { value: maximum_price_final_price_value, currency } = maximum_price_final_price || {};

  const { value: minimum_price_final_price_value } = minimum_price_final_price || {};

  // cp 划线价使用 max 里面的 regular_price
  if (product?.__typename === 'ConfigurableProduct') {
    return {
      finalPrice: minimum_price_final_price_value,
      crossPrice: maximum_price_regular_price_value,
      hasCrossPrice: minimum_price_final_price_value < maximum_price_regular_price_value,
      currency: currency || 'USD',
    };
  }

  // amp 与 simple  商品划线价使用 max 里面的 final_price
  return {
    finalPrice: minimum_price_final_price_value,
    crossPrice: maximum_price_final_price_value,
    hasCrossPrice: minimum_price_final_price_value < maximum_price_final_price_value,
    currency: currency || 'USD',
  };
};
